document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.button-tabs__trigger');
  const tabContents = document.querySelectorAll('.button-tabs__content');

  tabButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      // Remove 'active' class from all buttons and contents
      tabButtons.forEach(function (btn) {
        btn.classList.remove('active');
      });
      tabContents.forEach(function (content) {
        content.classList.remove('active');
      });

      // Add 'active' class to the clicked button and the corresponding content
      this.classList.add('active');
      const targetContent = document.getElementById(this.getAttribute('data-tab-target'));
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });
});
